import { ITask } from '../../TInvoker';

export default function aggregateSuccessful(tasks: ReadonlyArray<ITask>): any[] {
    return tasks
        .map((item) => item.result?.value)
        .filter((result) => typeof result !== 'undefined');
}
